import React, { useEffect, useState } from 'react';
import './HomePage.css';
import { useNavigate } from 'react-router-dom';
import Footer from '../../components/Footer/Footer';

const HomePage = () => {
    const navigate = useNavigate();
    const [showConfirmPopup, setShowConfirmPopup] = useState(false);
    const [contact, setContact] = useState({
        name: '',
        email: '',
        message: ''
    });

    useEffect(() => {
        fetch('https://3nrqnhje08.execute-api.us-east-2.amazonaws.com/api/Users/HomePageHit', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
            // no body
        }).catch((err) => console.error('Failed to record home page hit', err));
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setContact((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleContactSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch('https://3nrqnhje08.execute-api.us-east-2.amazonaws.com/api/ContactUs/SubmitContactForm', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(contact),
            });
            const result = await response.json();
            if (response.ok) {
                setShowConfirmPopup(true);
                setContact({ name: '', email: '', message: '' });

            } else {
                console.error('Failed to submit form:', result);
            }
        } catch (error) {
            console.error('Error occurred during submission:', error);
        }
    };

    const faqData = {
        general: [
            { question: "What is Victory Lane Authentication?", answer: "Victory Lane Authentication is the premier online service dedicated to authenticating NASCAR and other motorsports autographs." },
            { question: "Why Victory Lane Authentication vs the other guys?", answer: "Our team specializes in racing memorabilia, offering unmatched knowledge of NASCAR drivers and other motorsports drivers like Indycar to ensure fast, accurate, and trustworthy results. No shipping required, unlike traditional services, we bring expert authentication straight to your screen, saving you time, money, and hassle. With a lower cost and a streamlined process, Victory Lane Authentication is your trusted pit stop for verifying the signatures that fuel your collection." },
            { question: "What type of items can I get autographs authenticated on?", answer: "Victory Lane Authentication can authenticate autographs on ANY item! Due to no shipping being required you can get an autograph on anything from a trading card up to a piece of NASCAR sheetmetal authenticated!" },
            { question: "Why authenticate my racing autograph collection?", answer: "Authenticating your autographs enhances their value and builds trust with both you and potential buyers." },
            { question: "How will I know when the authentication process for my item is complete?", answer: "Once a determination regarding your item's authenticity has been made, you will receive an email notification with the results. If the item is deemed authentic, a physical Certificate of Authenticity (COA) will be mailed to you shortly thereafter." },
            { question: "How long will it take for my item to be authenticated?", answer: "You can expect to receive the authentication results via email within three days of placing your order." },
	        { question: "Can I submit a single order containing multiple items for authentication?", answer: "Yes. After adding your first item to the cart, simply return to the initial submission page to add additional items for authentication. Each item will be added to your cart as you complete the required information" },
        ]
    };
    const [activeTab, setActiveTab] = useState("general");
    const [faqOpen, setFaqOpen] = useState(Array(faqData[activeTab].length).fill(false));

    const toggleFaq = (index) => {
        setFaqOpen((prev) => {
            const newOpen = [...prev];
            newOpen[index] = !newOpen[index];
            return newOpen;
        });
    };

    useEffect(() => {
        const contents = document.querySelectorAll('.HomePage-section-content');
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('visible');
                        observer.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.1 }
        );

        contents.forEach((content) => observer.observe(content));

        return () => {
            contents.forEach((content) => observer.unobserve(content));
        };
    }, []);

    return (
        <div>
            <div className="HomePage-row">
                <div className="HomePage-logo-overlay">
                    <img
                        src={require('./vla_home_page_logo.png')}
                        alt="Victory Lane Logo"
                    />
                </div>
            </div>

            {/* How It Works Section */}
            <section className="HomePage-how-it-works-section">
                <div className="HomePage-section-content">
                    <h1 className="HomePage-section-title">Why Victory Lane Authentication?</h1>

                    <h2 className="HomePage-section-title-prices">Authentication prices range from $5 to $25! Free Shipping!</h2>

                    <a onClick={() => navigate('/signup')}>
                        <button className="HomePage-track-button">Sign Up To Start Your Authentication</button>
                    </a>

                    {/* Info Cards */}
                    <div className="HomePage-info-container">
                        <div className="HomePage-info-card">
                            <ul className="tick-list">
                                <li>
                                    <span className="tick">&#10003;</span>
                                    <strong>Increase Collectability</strong>: Determine authentication by racing specialized experts.
                                </li>
                                <li>
                                    <span className="tick">&#10003;</span>
                                    <strong>Increase Value</strong>: Generate Confidence in buyers. Receive a COA for your item.
                                </li>
                                <li>
                                    <span className="tick">&#10003;</span>
                                    <strong>Low Cost</strong>: No shipping cost for items. Variable pricing structure.
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div className="HomePage-how-it-works-steps">
                        <>
                            <div className="step active">
                                <span className="step-number">Step 1</span>
                                <p>Capture High-Quality Images of Your Item</p>
                            </div>
                            <div className="step">
                                <span className="step-number">Step 2</span>
                                <p>Submit Your Authentication Request</p>
                            </div>
                            <div className="step">
                                <span className="step-number">Step 3</span>
                                <p>Expert Evaluation by Our Authentication Team with the Help of AI</p>
                            </div>
                            <div className="step">
                                <span className="step-number">Step 4</span>
                                <p>Promptly Receive Your Authentication Results</p>
                            </div>
                            <div className="step">
                                <span className="step-number">Step 5</span>
                                <p>Certificate of Authenticity (COA) Delivered to Your Door</p>
                            </div>
                            <div className="step">
                                <span className="step-number">Step 6</span>
                                <p>Permanent Record in Our Secure Online Database</p>
                            </div>
                        </>
                    </div>
                </div>
            </section>

            {/* FAQ & Contact Section */}
            <section className="HomePage-contact-faq-section">
                <div className="HomePage-section-content">
                    <h1 className="HomePage-section-title">Frequently Asked Questions</h1>
                    <div className="HomePage-faq">
                        {faqData[activeTab].map((item, index) => (
                            <div key={index} className={`HomePage-faq-item ${faqOpen[index] ? 'open' : ''}`}>
                                <div className="HomePage-faq-question" onClick={() => toggleFaq(index)}>
                                    <span>{item.question}</span>
                                    <span className="faq-toggle-icon">+</span>
                                </div>
                                {faqOpen[index] && (
                                    <div className="HomePage-faq-answer">
                                        <p>{item.answer}</p>
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>


                    <div className="Homepage-contact-container">
                        <div className="HomePage-contact-card">
                            <h1 className="HomePage-section-title">Get in Touch</h1>
                            <p className="HomePage-contact-description">
                                Drop us a message about any questions and we will get back to you soon!
                            </p>
                            <form className="HomePage-contact-form" onSubmit={handleContactSubmit}>
                                <input
                                    type="text"
                                    name="name"
                                    placeholder="Your Name"
                                    className="HomePage-contact-input"
                                    required
                                    onChange={handleInputChange}
                                    value={contact.name}
                                />
                                <input
                                    type="email"
                                    name="email"
                                    placeholder="Your Email"
                                    className="HomePage-contact-input"
                                    required
                                    onChange={handleInputChange}
                                    value={contact.email}
                                />
                                <textarea
                                    name="message"
                                    placeholder="Your Message"
                                    className="HomePage-contact-textarea"
                                    required
                                    onChange={handleInputChange}
                                    value={contact.message}
                                ></textarea>
                                <button type="submit" className="HomePage-contact-button">Send Message</button>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    );
};

export default HomePage;
